import autobind from "autobind-decorator";
import React from "react";

import { IViewProps, View } from "core/decorators/View";
import HeadingView from "../heading/Heading.view";
import { Bar, Label, LabelSpacer, Legend, Node, Separator, SeparatorMode } from "./styled";
import TimelineViewConfig from "./TimelineViewConfig";

export interface ITimelineNode {
	label: string | JSX.Element;
	value?: number; // 0 - 1
	active: boolean;
}

export interface ITimelineViewProps extends IViewProps<TimelineViewConfig> {
	nodes: ITimelineNode[];
}

@View({id: "timeline", configClass: TimelineViewConfig})
export class TimelineView extends React.Component<ITimelineViewProps> {

	@autobind
	private renderSegments(conditions: ITimelineNode[]) {
		const { config } = this.props;

		return conditions.map((node, index) => {
			let mode = SeparatorMode.EMPTY;

			if(node.active && (conditions[index + 1] && conditions[index + 1].active)) {
				mode = SeparatorMode.FULL;
			} else if(node.active) {
				mode = SeparatorMode.HALF;
			}

			return (
				<React.Fragment>
					<Node active={node.active} config={config} />

					{index !== (conditions.length - 1) && (
						<Separator mode={mode} config={config} />
					)}
				</React.Fragment>
			);
		});
	}

	@autobind
	private renderLabels(conditions: ITimelineNode[]) {
		const { config } = this.props;


		return conditions.map((node, index) => (
			<React.Fragment>
				<Label>
					<HeadingView viewKey="timeline.label">
						{node.label}
					</HeadingView>
				</Label>

				{index !== (conditions.length - 1) && (
					<LabelSpacer  config={config} />
				)}
			</React.Fragment>
		));
	}

	public render() {
		const { nodes } = this.props;

		return (
			<React.Fragment>
				<Bar>
					{this.renderSegments(nodes)}
				</Bar>
				<Legend>
					{this.renderLabels(nodes)}
				</Legend>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/timeline/Timeline.view.tsx